import http from "./httpClient";

const link = "/CGSService/FrogiGo/";
const publicService = "PublicService/";
const memberOperation = "MemberOperation/";

// Public Service
const LOGIN_USER = link + publicService + "Login";
const REGISTER_USER = link + publicService + "register";
const SELECT_COUNTRY = link + publicService + "SelectCountry";
const VERIFY_BY_EMAIL = link + publicService + "VerifyByEmail";
const VERIFY_BY_SMS = link + publicService + "VerifyBySms";
const VALIDATE_SHORT_CODE = link + publicService + "ValidShortCode";
const GET_WEBSITE_BASIC_CONTENT =
  link + publicService + "GetWebsiteBasicContent";
const GET_WEBSITE_BASIC_CONTENT_VER =
  link + publicService + "GetWebsiteBasicContentVer";
const GET_NEWS = link + publicService + "GetWebsiteNews";
const GET_SELF_PICKUP_SPOT = link + publicService + "GetSelfPickupSpot";
const GET_SELF_PICKUP_SPOT_BY_NO = link + publicService + "GetSelfPickupSpotByNo";
const SELECT_ZONE_NAMES = link + publicService + "SelectZoneNames";
const SELECT_CITY = link + publicService + "SelectCity";
const SEARCH_NEWS = link + publicService + "SearchNews";

const FORGOT_BY_SMS = link + publicService + "ForgotBySms";
const FORGOT_BY_EMAIL = link + publicService + "ForgotByEmail";
const RESET_PASSWORD = link + publicService + "ResetPassword";

const GET_APP_LATEST_VERSIONS = link + publicService + "GetAppLatestVersions";
const INSERT_MEMBER_DEVICE = link + publicService + "InsertMemberDevice";

// Member Operation
const LOGOUT_USER = link + memberOperation + "Logout";
const IS_AUTH = link + memberOperation + "IsAuth";
const ADD_ORDER = link + memberOperation + "AddOrder";
const GET_ORDER = link + memberOperation + "GetOrder";
const UPDATE_ORDER = link + memberOperation + "UpdateOrder";
const UPDATE_GATED_IN_ORDER = link + memberOperation + "UpdateGatedInOrder";
const VOID_ORDER = link + memberOperation + "VoidOrder";
const SEARCH_ORDER = link + memberOperation + "GetOrderByStatus";
const SELECT_SERVICE_CENTER = link + memberOperation + "GetServiceCenterByType";
const GET_DEFAULT_SERVICE_CENTER =
  link + memberOperation + "GetDefaultServiceCenter";

const ADD_BUNDLE = link + memberOperation + "AddBundle";
const GET_BUNDLE = link + memberOperation + "GetBundle";
const SEARCH_BUNDLE = link + memberOperation + "SearchBundle";
const UPDATE_PAYMENT_METHOD = link + memberOperation + "UpdatePaymentMethod";
const CHECKOUT = link + memberOperation + "Checkout";
const INQUERY_PAYMENT = link + memberOperation + "InquiryPayment";
const CLAIM_CARGO = link + memberOperation + "ClaimCargo";
const GET_SIGNBACK_IMG = link + memberOperation + "GetSignBackImg";
const GET_SIGNBACK_IMG2 = link + memberOperation + "GetSignBackImg2";

// Member Address
const GET_MEMBER_ADDRESS = link + memberOperation + "GetMemberAddress";
const GET_DEFAULT_MEMBER_ADDRESS =
  link + memberOperation + "GetDefaultMemberAddress";
const GET_DEFAULT_PICKUP = link + memberOperation + "GetDefaultPickup";
const MUST_USE_PICKUP = link + memberOperation + "MustUsePickup";
const SAVE_MEMBER_ADDRESS = link + memberOperation + "SaveMemberAddress";
const DELETE_MEMBER_ADDRESS = link + memberOperation + "DeleteMemberAddress";
const SAVE_MEMBER_DEFAULT = link + memberOperation + "SaveMemberDefault";
const GET_COUNTRY = link + memberOperation + "GetCountry";

const SELECT_COUPON = link + memberOperation + "GetAvailableMemberCoupon";
const SEARCH_COUPON = link + memberOperation + "SearchMemberCoupon";

const SEARCH_MESSAGE_NOTIFICATION =
  link + memberOperation + "SearchMessageNotification";
const GET_MESSAGE_NOTIFICATION =
  link + memberOperation + "GetMessageNotification";
const RETRIEVE_MESSAGE_NOTIFICATION =
  link + memberOperation + "RetrieveMessageNotification";
const SET_MESSAGE_READ = link + memberOperation + "SetMessageRead";
const HAS_UNREAD_MESSAGE_NOTIFICATION =
  link + memberOperation + "HasUnreadMessageNotification";

const GET_MEMBER = link + memberOperation + "GetMember";
const UPDATE_MEMBER = link + memberOperation + "UpdateMember";
const UPDATE_MEMBER_EMAIL = link + memberOperation + "UpdateMemberEmail";
const UPDATE_MEMBER_MOBILE = link + memberOperation + "UpdateMemberMobileNo";
const VERIFY_BY_SMS_MEMBER = link + memberOperation + "VerifyBySms";
const VERIFY_BY_EMAIL_MEMBER = link + memberOperation + "VerifyByEmail";
const CHANGE_PASSWORD = link + memberOperation + "ChangePassword";

const SystemLogin = data => {
  return post(LOGIN_USER, data, true);
};

const SystemLogout = () => {
  return post(LOGOUT_USER, {}, true);
};
const RegisterUser = data => {
  return post(
    REGISTER_USER +
      (data.SalesCode != undefined ? "?SalesCode=" + data.SalesCode : ""),
    data
  );
};

const GetCountry = data => {
  return post(GET_COUNTRY, data);
};

const SelectCountry = data => {
  return post(SELECT_COUNTRY, data);
};

const VerifyByEmail = data => {
  return post(VERIFY_BY_EMAIL, data);
};

const VerifyBySms = data => {
  return post(VERIFY_BY_SMS, data);
};

const ValidateShortCode = data => {
  return post(VALIDATE_SHORT_CODE, data);
};

const GetWebsiteBasicContent = data => {
  return post(GET_WEBSITE_BASIC_CONTENT, data);
};
const GetWebsiteBasicContentVer = data => {
  return post(GET_WEBSITE_BASIC_CONTENT_VER, data);
};

const GetNews = data => {
  return post(GET_NEWS, data);
};

const IsAuth = data => {
  return post(IS_AUTH, data, true);
};

const AddOrder = data => {
  return post(ADD_ORDER, data, true);
};

const GetOrder = data => {
  return post(GET_ORDER, data, true);
};

const UpdateOrder = data => {
  return post(UPDATE_ORDER, data, true);
};

const UpdateGatedInOrder = data => {
  return post(UPDATE_GATED_IN_ORDER, data, true);
};

const VoidOrder = data => {
  return post(VOID_ORDER, data, true);
};

const SearchOrder = data => {
  return post(SEARCH_ORDER, data, true);
};

const SelectServiceCenter = data => {
  return post(SELECT_SERVICE_CENTER, data, true);
};

const GetDefaultServiceCenter = data => {
  return post(GET_DEFAULT_SERVICE_CENTER, data, true);
};

const AddBundle = data => {
  return post(ADD_BUNDLE, data, true);
};

const GetBundle = data => {
  return post(GET_BUNDLE, data, true);
};

const SearchBundle = data => {
  return post(SEARCH_BUNDLE, data, true);
};

const UpdatePaymentMethod = data => {
  return post(UPDATE_PAYMENT_METHOD, data, true);
};

const Checkout = data => {
  return post(CHECKOUT, data, true);
};

const InquiryPayment = data => {
  return post(INQUERY_PAYMENT, data, true);
};

const ClaimCargo = data => {
  return post(CLAIM_CARGO, data, true);
};

const GetSignBackImg = data => {
  return post(GET_SIGNBACK_IMG, data, true);
};

const GetSignBackImg2 = (path) => {
  return get(GET_SIGNBACK_IMG2+path, true);
};

const GetMemberAdd = data => {
  return post(GET_MEMBER_ADDRESS, data, true);
};

const GetDefaultMemberAdd = data => {
  return post(GET_DEFAULT_MEMBER_ADDRESS, data, true);
};

const GetDefaultPickup = data => {
  return post(GET_DEFAULT_PICKUP, data, true);
};

const MustUsePickup = data => {
  return post(MUST_USE_PICKUP, data, true);
};

const SaveMemberAdd = data => {
  return post(SAVE_MEMBER_ADDRESS, data, true);
};

const DeleteMemberAdd = data => {
  return post(DELETE_MEMBER_ADDRESS, data, true);
};

const SaveMemberDefault = data => {
  return post(SAVE_MEMBER_DEFAULT, data, true);
};

const GetSelfPickupSpot = data => {
  return post(GET_SELF_PICKUP_SPOT, data, true);
};

const GetSelfPickupSpotByNo = data => {
  return post(GET_SELF_PICKUP_SPOT_BY_NO, data, true);
};

const SelectZoneNames = data => {
  return post(SELECT_ZONE_NAMES, data, true);
};

const SelectCity = data => {
  return post(SELECT_CITY, data, true);
};

const SelectCoupon = data => {
  return post(SELECT_COUPON, data, true);
};

const SearchMemberCoupon = data => {
  return post(SEARCH_COUPON, data, true);
};

const SearchMessageNotification = data => {
  return post(SEARCH_MESSAGE_NOTIFICATION, data, true);
};

const GetMessageNotification = data => {
  return post(GET_MESSAGE_NOTIFICATION, data, true);
};

const RetrieveMessageNotification = data => {
  return post(RETRIEVE_MESSAGE_NOTIFICATION, data, true);
};

const SetMessageRead = data => {
  return post(SET_MESSAGE_READ, data, true);
};

const HasUnreadMessageNotification = data => {
  return post(HAS_UNREAD_MESSAGE_NOTIFICATION, data, true);
};

const SearchNews = data => {
  return post(SEARCH_NEWS, data);
};

const ForgotBySms = data => {
  return post(FORGOT_BY_SMS, data);
};

const ForgotByEmail = data => {
  return post(FORGOT_BY_EMAIL, data);
};

const ResetPassword = data => {
  return post(RESET_PASSWORD, data);
};

const GetAppLatestVersions = data => {
  return post(GET_APP_LATEST_VERSIONS, data);
};

const InsertMemberDevice = data => {
  return post(INSERT_MEMBER_DEVICE, data);
};

const GetMember = data => {
  return post(GET_MEMBER, data, true);
};

const UpdateMember = data => {
  return post(UPDATE_MEMBER, data, true);
};

const UpdateMemberEmail = data => {
  return post(UPDATE_MEMBER_EMAIL, data, true);
};

const UpdateMemberMobile = data => {
  return post(UPDATE_MEMBER_MOBILE, data, true);
};

const VerifyBySmsMember = data => {
  return post(VERIFY_BY_SMS_MEMBER, data, true);
};

const VerifyByEmailMember = data => {
  return post(VERIFY_BY_EMAIL_MEMBER, data, true);
};

const ChangePassword = data => {
  return post(CHANGE_PASSWORD, data, true);
};

function post(url, data, withCredentials = false, timeout = 20000) {
  return http.post(url, JSON.stringify(data), {
    timeout: timeout,
    withCredentials: withCredentials
  });
}

function get(url, withCredentials = false, timeout = 20000, responseType='blob') {
  return http.get(url, {
    timeout: timeout,
    withCredentials: withCredentials,
    responseType: responseType
  });
}

export {
  SystemLogin,
  RegisterUser,
  SelectCountry,
  VerifyByEmail,
  VerifyBySms,
  ValidateShortCode,
  GetWebsiteBasicContent,
  GetWebsiteBasicContentVer,
  GetNews,
  SearchNews,
  SystemLogout,
  IsAuth,
  AddOrder,
  GetOrder,
  UpdateOrder,
  UpdateGatedInOrder,
  VoidOrder,
  SearchOrder,
  SelectServiceCenter,
  GetDefaultServiceCenter,
  AddBundle,
  GetBundle,
  SearchBundle,
  UpdatePaymentMethod,
  Checkout,
  InquiryPayment,
  ClaimCargo,
  GetSignBackImg,
  GetSignBackImg2,
  GetMemberAdd,
  GetDefaultMemberAdd,
  GetDefaultPickup,
  MustUsePickup,
  SaveMemberAdd,
  DeleteMemberAdd,
  SaveMemberDefault,
  GetCountry,
  GetSelfPickupSpot,
  GetSelfPickupSpotByNo,
  SelectZoneNames,
  SelectCity,
  SelectCoupon,
  SearchMemberCoupon,
  SearchMessageNotification,
  GetMessageNotification,
  RetrieveMessageNotification,
  SetMessageRead,
  HasUnreadMessageNotification,
  ForgotBySms,
  ForgotByEmail,
  ResetPassword,
  GetAppLatestVersions,
  InsertMemberDevice,
  GetMember,
  UpdateMember,
  UpdateMemberEmail,
  UpdateMemberMobile,
  VerifyBySmsMember,
  VerifyByEmailMember,
  ChangePassword
};
